import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

export default class FormController extends Controller {
  static outlets = ["dependable-frame"]
  static targets = ["form", "clearableField", "autofocusField", "submitButton"]
  static values = {
    shouldDebounce: Boolean,
  }

  initialize() {
    if (this.shouldDebounceValue) {
      this.submit = debounce(this.submit, 200).bind(this)
    }

    if (this.hasAutofocusFieldTarget) {
      this.autofocusFieldTarget.focus()
    }
  }

  submit() {
    this.#target.requestSubmit()
  }

  submitted(e) {
    if (e.detail.success) {
      this.#reRenderDependableFrames(e)
      this.dispatch("success", { detail: e.detail })
    } else {
      this.dispatch("error", { detail: e.detail })
    }
  }

  ensureSubmitEnabled(e) {
    if (this.submitButtonTarget && this.submitButtonTarget.disabled) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  clear() {
    this.clearableFieldTargets.forEach((clearableField) => {
      clearableField.value = ""
    })
  }

  clearAndSubmit() {
    this.clear()
    this.submit()
  }

  disableElements() {
    Array.from(this.#target.elements).forEach((elem) => (elem.disabled = true))
  }

  reset() {
    this.#target.reset()
  }

  get #target() {
    return this.hasFormTarget ? this.formTarget : this.element
  }

  async #reRenderDependableFrames(e) {
    const responseHTML = await e.detail.fetchResponse.responseHTML
    const doc = new DOMParser().parseFromString(responseHTML, "text/html")

    this.dependableFrameOutlets.forEach((dependableFrame) => {
      dependableFrame.renderFromDocument(doc)
    })
  }
}
